import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { BOX_SHADOWS, FONTS } from "../../constants";
import { stateType, stateTypeF } from "../../state";
import { Legend } from "../Common/Legend";
import { HelpIcon } from "../Common/ToolTipIcon";
import {
  CHART_COLOR,
  CHART_COLORS,
  ClusterChart,
  MULTI_COLOR,
  OTHER_COLOR,
  TEXT_COLOR,
} from "./clusterChart/ClusterChart";
import { getEmptyCustomTopic, MAX_TOPICS } from "./CustomTopicTable";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      boxShadow: BOX_SHADOWS,
      backgroundImage: CHART_COLOR,
      width: "100%",
      height: "500px",
      display: "flex",
      flexDirection: "column",
      borderRadius: "10px",
      overflow: "hidden",
    },
  })
);

type inputType = { nClusters: number; state: stateTypeF };

export const ClusterBox = ({ state }: stateType) => {
  let classes = useStyles();

  const ndx = state.saveState.topicModeling.varSelected;
  const customTopicsData =
    state.saveState.dataset.visualizationData[ndx].customTopicsData;

  if (customTopicsData.customTopics === undefined) {
    customTopicsData.customTopics = Array(MAX_TOPICS)
      .fill(0)
      .map((_, i) => getEmptyCustomTopic(i));
    state.setSaveState(state.saveState);
    return <div></div>;
  }

  let labels: string[] = [];
  let colors: string[] = [];
  let unqGroups = [];
  if (customTopicsData.groups !== undefined) {
    unqGroups = Array.from(new Set(customTopicsData.groups)).sort();
    for (let group of unqGroups) {
      if (group === customTopicsData.multiTopicIndex) {
        labels.push("Multiple Topics");
        colors.push(MULTI_COLOR);
      } else if (group === customTopicsData.noTopicIndex) {
        labels.push("Other");
        colors.push(OTHER_COLOR);
      } else {
        let topicName = customTopicsData.customTopics[group].topicName;
        labels.push(topicName);
        colors.push(CHART_COLORS[group]);
      }
    }
  }

  return (
    <div className={classes.container}>
      <div
        style={{
          color: TEXT_COLOR,
          position: "absolute",
          fontFamily: FONTS,
          marginLeft: "30px",
          fontSize: "30px",
          marginTop: "10px",
          zIndex: 1000,
          display: "flex",
          flexDirection: "row",
        }}
      >
        Topic Visualizer{" "}
        <HelpIcon
          color={TEXT_COLOR}
          title={
            "Each point represents text extracted from your data. Points close to each other represent text which is similar in topic."
          }
          marginLeft={"5px"}
          paddingTop={"0px"}
          marginBottom={"5px"}
        ></HelpIcon>
      </div>
      {/* <DiscreteSlider nClusters={nClusters} state={state}></DiscreteSlider> */}
      <ClusterChart state={state}></ClusterChart>
      {unqGroups.length > 1 ? (
        <Legend labels={labels} colors={colors}></Legend>
      ) : (
        <div></div>
      )}
    </div>
  );
};
